import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {environment} from '../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-industry-edit',
  templateUrl: './industry-edit.component.html',
  styleUrls: ['./industry-edit.component.css']
})
export class IndustryEditComponent implements OnInit {

  industryId ;
  indDetails = [];
  realIndDetails = {};
  formErrorVendorId = '';
  production = environment.production;
  formErrorLong = '';
  addOn = '';
  formErrorOcmmsId = '';
  formErrorOfficer = '';
  formErrorCategoryType = '';
  formErrorZip = '';
  formErrorAddress = '';
  formErrorIndName = '';
  formErrorCategory = '';
  formErrorCity = '';
  formErrorLat = '';
  formErrorMonitoringType = '';
  userData:any = [];
  userName = null;

  updateIndLoader = false;
  showWebcamPassword: boolean = false;
  getIndustryDetailLoader = false;
  headingTitle = 'Update Industry Details';
  editView = 'industry';
  route;
  officerList = [];
  type = 'view';
  error = false;
  userLevel;
  archive;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {

    this.activeroute.queryParams.subscribe(params => {
      this.industryId = atob(params['industry_id']);
      this.type = atob(params['type']);
      if(params['archive']){
        this.archive = params['archive'];
      }
    });

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];

      if( ((this.type == 'edit') && (this.userLevel != 'admin')) && this.production == true ){
        if(this.userName != 'HSPCBCEMS'){
          this.type = 'view';
        }
      }

      if((this.userLevel != 'admin' && this.userName != 'HSPCBCEMS') && this.production == true){
        if(this.type != 'view') {
          this.router.navigate(['dashboard']);
        }
      }
    }

    this.getIndustryDetail();
    this.getOfficerList();
  }

/* toggleWebcamPassword() {
  this.showWebcamPassword = !this.showWebcamPassword;
} */


  switchView(type){

    if(this.type == 'edit'){
      this.addOn = 'Update';
    }else{
      this.addOn = 'View';
    }

    if(type == 'industry'){
      this.headingTitle = this.addOn +' Industry Details';
      this.getIndustryDetail();
      this.getOfficerList();
    }

    if(type == 'station'){
      this.headingTitle = this.addOn +' Station Details';
    }

    if(type == 'device'){
      this.headingTitle = this.addOn + ' Device Details';
    }

    if(type == 'parameter'){
      this.headingTitle = this.addOn + ' Parameter Details';
    }

    if(type == 'add'){
      this.headingTitle = 'Add New Details';
    }

    this.editView = type;

  }

  getOfficerList(){

    this.route  = 'get-officer-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officerList = response.data;
      }
    });
  }

  getIndustryDetail(){
    this.getIndustryDetailLoader = true;
    this.route  = 'get-industry-profile-details';
    const token    = localStorage.getItem('userToken');
    this.indDetails = [];
    this.realIndDetails = {};

    let data = {'industry_id':this.industryId, 'is_archive':this.archive};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.getIndustryDetailLoader = false;
        if(response.data.length){
          this.indDetails = response.data[0];
          this.realIndDetails = JSON.stringify(response.data[0]);
        }
      }
    });
  }

  validateIndustry(){

    this.error = false;

    if(this.indDetails['industry_category'] && this.indDetails['industry_category'].trim() && this.indDetails['industry_category'].trim() != ' '){
      this.formErrorCategory = '';
    }else{
      this.formErrorCategory = 'Category Type is required';
      this.error = true;
    }

    if(this.indDetails['vendor_ind_id'] && this.indDetails['vendor_ind_id'].trim() && this.indDetails['vendor_ind_id'].trim() != ' '){
      this.formErrorVendorId = '';
    }else{
      this.formErrorVendorId = 'Industry id is required';
      this.error = true;
    }

    if(this.indDetails['name'] && this.indDetails['name'].trim() && this.indDetails['name'].trim() != ' '){
      this.formErrorIndName = '';
    }else{
      this.formErrorIndName = 'Industry name is required';
      this.error = true;
    }

    if(this.indDetails['address'] && this.indDetails['address'].trim() && this.indDetails['address'].trim() != ' '){
      this.formErrorAddress = '';
    }else{
      this.formErrorAddress = 'Industry address is required';
      this.error = true;
    }

    if(this.indDetails['city'] && this.indDetails['city'].trim() && this.indDetails['city'].trim() != ' '){
      this.formErrorCity = '';
    }else{
      this.formErrorCity = 'Industry city is required';
      this.error = true;
    }

    if(this.indDetails['industry_type'] && this.indDetails['industry_type'] != ' '){
      this.formErrorCategoryType = '';
    }else{
      this.formErrorCategoryType = 'Category Name is required';
      this.error = true;
    }

    if(this.indDetails['zip'] && this.indDetails['zip'] != ' '){
      this.formErrorZip = '';
    }else{
      this.formErrorZip = 'Industry zip is required';
      this.error = true;
    }

    if(this.indDetails['latitude'] && this.indDetails['latitude'] != ' '){
      this.formErrorLat = '';
    }else{
      this.formErrorLat = 'Industry latitude is required';
      this.error = true;
    }

    if(this.indDetails['regional_officer_id'] && this.indDetails['regional_officer_id'] != ' '){
      this.formErrorOfficer = '';
    }else{
      this.formErrorOfficer = 'Please select officer';
      this.error = true;
    }

    if(this.indDetails['hr_ocmms_id'] && this.indDetails['hr_ocmms_id'].trim() && this.indDetails['hr_ocmms_id'].trim() != ' '){
      this.formErrorOcmmsId = '';
    }else{
      this.formErrorOcmmsId = 'OCMMS id is required';
      this.error = true;
    }

    if(this.indDetails['emmision_type'] && this.indDetails['emmision_type'].trim() && this.indDetails['emmision_type'].trim() != ' '){
      this.formErrorMonitoringType = '';
    }else{
      this.formErrorMonitoringType = 'Monitoring type is required';
      this.error = true;
    }

    if(this.indDetails['longitude'] && this.indDetails['longitude'] != ' ') {
      this.formErrorLong = '';
    }else{
      this.formErrorLong = 'Industry longitude is required';
      this.error = true;
    }

    if(this.error){
      Swal('Error', 'Please provide complete details!', 'error');
    }else{

      this.updateIndLoader = true;
      this.route  = 'update-industry-detail';
      const token = localStorage.getItem('userToken');
      this.indDetails['real_dataset'] = this.realIndDetails;
      this.indDetails['user_id'] = this.userName;
      console.log(this.indDetails);
      let data = this.indDetails;
console.log(this.indDetails);
      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        this.updateIndLoader = false;
        if(response.status == 200){
          this.getIndustryDetail();
          Swal('Success', 'Industry details updated successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }

}
